module.exports = __webpack_public_path__ + "static/media/heavy_pound31.ddae0566.jpg";